module.exports = __webpack_public_path__ + "static/media/arch3.def9ff86.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/arch3.jpg
// module id = 5790
// module chunks = 0